import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
  bulkInventoryBinService,
  type UpdateServiceTypeRequest,
  type UpdateServiceTypeResponse,
} from '@/services/propertyBook/BulkInventoryBinService';
import { queryKeys } from '@/lib/queryKeys';

export const useUpdateBinServiceType = () => {
  const queryClient = useQueryClient();

  return useMutation<UpdateServiceTypeResponse, unknown, UpdateServiceTypeRequest>({
    mutationFn: (payload) => bulkInventoryBinService.updateServiceType(payload),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: queryKeys.bulkInventoryBin.list() });
      void queryClient.invalidateQueries({ queryKey: queryKeys.entities.lists() });
    },
  });
};
